import React, { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from "../../routes/PrivateRoute";
import { Spinner } from '../Common/Spinner';
import CourseCompletionForm from './CourseCompletionForm';
import CertificateVerify from './CertificateVerify';
import CertificatePublicView from './CertificatePublicView';
const CourseCompletionListTable = lazy(() => import('./List/CourseCompletionListTable'));

const CourseCompletionsRouter = (props) => (
  <Suspense fallback={<Spinner />}>
    <Route path="/certificate/public/:id" component={CertificatePublicView} exact />
    <Route path="/verify/certificate/:id" component={CertificateVerify} exact />
    <PrivateRoute path="/list/course_completions" searchString={props.searchString} component={CourseCompletionListTable} exact />
    <PrivateRoute path="/course_completion/:id?" component={CourseCompletionForm} exact />
  </Suspense>
)

export default CourseCompletionsRouter;